export default __webpack_public_path__ + "static/qacase1-6f11e901bdde78334db4167e7f320ac1.png";